import { AnchorButton } from "@blueprintjs/core";
import styled from "styled-components";

const ThemeAnchorButton = styled(AnchorButton)`
  font-weight: var(--global-font-weight-regular);
  box-shadow: -1px 4px 8px rgba(0, 0, 0, 0.15);
  height: 32px;
  padding: 12px;

  &:is([class*="bp3-large"]) {
    font-size: var(--global-font-size-m);
    height: 3em;
    line-height: 24px;
  }
  &:is([class*="bp3-small"]) {
    height: 1em;
  }
  &:not([class*="bp3-intent-"]) {
    :hover {
      color: inherit;
    }
  }
  &:is([class*="bp3-disabled"]) {
    text-shadow: none !important;
    :hover {
      color: inherit !important;
      background-color: rgba(255, 255, 255, 0.2) !important;
    }
  }
`;

const FilledButton = styled(ThemeAnchorButton)`
  &:not([class*="bp3-intent-"]) {
    color: #ffffff;
    transition: 250ms;
    text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.6);
    box-shadow: -1px 4px 8px rgba(0, 0, 0, 0.15);
    :hover {
      color: #ffffff;
      text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.6);
      box-shadow: -1px 4px 8px rgba(0, 0, 0, 0.15);
    }
  }
`;

// This bright green button should ONLY be used for marketing purposes
// (ex: homepage, login screen) because at a normal size, the bright
// green color makes it not accessible
export const GreenButton = styled(FilledButton)`
  &:not([class*="bp3-intent-"]) {
    background: var(--button-green);
    :hover {
      background: var(--button-green-hover);
    }
    :active {
      background: var(--button-green-active);
    }
  }
`;

const PurpleHighlightButton = styled(FilledButton)`
  &:not([class*="bp3-intent-"]) {
    background: var(--global-purple-highlight);
    text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.4);
    :hover {
      background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 0.2),
          rgba(255, 255, 255, 0.2)
        ),
        var(--global-purple-highlight);
    }
  }
`;

export const PurpleHighlightTagButton = styled(PurpleHighlightButton)`
  border-radius: 16px;
  padding: 0 8px;
  height: 20px;
  font-size: var(--global-font-size-xs);
  margin-bottom: var(--global-spacing-s);
`;

const OutlineButton = styled(ThemeAnchorButton)`
  &:not([class*="bp3-intent-"]) {
    background-color: transparent;
    color: inherit;
    box-shadow: none;
    :hover {
      background: rgba(31, 27, 50, 0.4);
    }
    :active {
      background: rgba(31, 27, 50, 0.5);
    }
  }
`;

export const GreenOutlineButton = styled(OutlineButton)`
  border: 1px solid var(--button-green);
  background-image: none !important;
`;

// Just a button that looks like a link!
export const LinkButton = styled.button`
  border: none;
  color: var(--link-color);
  background: none;
  :hover {
    color: var(--link-color-hover);
    text-decoration: underline;
    cursor: pointer;
  }
`;

// When you cannot use blueprint because button
// is for a form
export const StyledFormButton = styled.button`
  height: 30px;
  border-radius: 5px;
  border: None;
  color: white;
  background-color: var(--button-indigo);
  text-shadow: 0px 1px 4px rgb(0 0 0 / 40%);
  box-shadow: -1px 4px 8px rgba(0, 0, 0, 0.15);
  :hover {
    cursor: pointer;
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.2),
        rgba(255, 255, 255, 0.2)
      ),
      var(--button-indigo);
  }
`;
